import React from "react";
import ModoExclusivo from "./ModoExclusivo.jsx";

const ModoExclusivoLista = (props) => {
    let modoExclusivoNodes;
    let showMessage = false;

    if (props.modoExclusivo && props.modoExclusivo.length > 0) {
        modoExclusivoNodes = props.modoExclusivo.map(function (em, index) {
            return (<ModoExclusivo data={em} key={index} />)
        });
    } else {
        showMessage = true;
        modoExclusivoNodes = null;
    }

    return (
        <div className="row bottom-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">Accede en modo exclusivo a</label>
            </div>
            {showMessage == false ?
                <div className="col-xs-12">
                    <ul className="list-unstyled">{modoExclusivoNodes}</ul>
                </div> : null}
        </div>
    );
}

export default ModoExclusivoLista;